<template>
  <div class="mb-12">
    <HistoryFilterSelect
      :options="options"
      title="내역 선택"
      :initValue="0"
      @select="selectedOption = $event"
    />
    <HistoryList :filter="selectedOption" class="mt-4" />
  </div>
</template>

<script>
import HistoryFilterSelect from './HistoryFilterSelect.vue'
import HistoryList from './HistoryList.vue'
export default {
  components: { HistoryFilterSelect, HistoryList },
  data() {
    return {
      selectedOption: 'all',
      options: [
        { value: 'all', text: '전체' },
        { value: 'payments', text: '사입비' },
        { value: 'repayments', text: '상환' },
        { value: 'mallDeposits', text: '플랫폼 입금' },
        { value: 'refunds', text: '셀러 반환' },
      ],
    }
  },
}
</script>
